import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';
import './advance-table.scss';

const AdvanceTable = ({
  getTableProps,
  headers,
  page,
  prepareRow,
  headerClassName,
  rowClassName,
  tableProps,
}) => {
  const [windowWidth, setWindowWidth] = React.useState(window.innerWidth);
  const isSM = windowWidth < 900;

  useEffect(() => {
    window.addEventListener('resize', () => {
      setWindowWidth(window.innerWidth);
    });
    return () => {
      window.addEventListener('resize', () => {
        setWindowWidth(window.innerWidth);
      });
    };
  }, []);

  return (
    <Table
      style={{
        display: isSM ? 'block' : 'table',
        overflowX: 'auto',
      }}
      {...getTableProps(tableProps)}
    >
      <thead className={headerClassName}>
        <tr>
          {headers.map((column, index) => (
            <th
              key={index}
              {...column.getHeaderProps(
                column.Header &&
                  column.Header !== '' &&
                  column.getSortByToggleProps(column.headerProps)
              )}
            >
              {column.render('Header')}
              {column.Header && column.Header !== '' && column.canSort ? (
                column.isSorted ? (
                  column.isSortedDesc ? (
                    <span className='sort-desc' />
                  ) : (
                    <span className='sort-asc' />
                  )
                ) : (
                  <span className='sort' />
                )
              ) : (
                ''
              )}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {tableProps.loader ? (
          <tr>
            <td colSpan={headers.length}>
              <div
                className='loading-overlay'
                style={{ backgroundColor: 'transparent' }}
              >
                <div className='loading'></div>
              </div>
            </td>
          </tr>
        ) : page.length > 0 ? (
          page.map((row, i) => {
            prepareRow(row);
            return (
              <tr key={i} className={rowClassName} {...row.getRowProps()}>
                {row.cells.map((cell, index) => {
                  return (
                    <td
                      key={index}
                      style={{ verticalAlign: 'middle' }}
                      {...cell.getCellProps(cell.column.cellProps)}
                    >
                      {cell.render('Cell')}
                    </td>
                  );
                })}
              </tr>
            );
          })
        ) : (
          <tr>
            <td colSpan={headers.length}>
              <div className='d-flex align-items-center justify-content-center'>
                No records to display
              </div>
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  );
};
AdvanceTable.propTypes = {
  getTableProps: PropTypes.func,
  headers: PropTypes.array,
  page: PropTypes.array,
  prepareRow: PropTypes.func,
  headerClassName: PropTypes.string,
  rowClassName: PropTypes.string,
  tableProps: PropTypes.object,
};

export default AdvanceTable;
